var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloud = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23.045,
  height: 17.28,
  viewBox: "0 0 23.045 17.28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_feather-cloud",
  "data-name": "Icon feather-cloud",
  d: "M8.637,4.5h0a8.634,8.634,0,0,1,8.139,5.761h.5a5.76,5.76,0,1,1,0,11.52H8.63A8.64,8.64,0,0,1,8.637,4.5Zm8.639,15.36a3.84,3.84,0,0,0,0-7.68h-1.21a.96.96,0,0,1-.929-.72,6.715,6.715,0,0,0-6.5-5.041,6.842,6.842,0,0,0-1.135.1,6.76,6.76,0,0,0-5.567,7.193,6.68,6.68,0,0,0,6.7,6.151Z",
  transform: "translate(0.009 -4.499)",
  fill: "currentColor"
})));
export { SvgCloud as ReactComponent };
export default __webpack_public_path__ + "static/media/cloud.6d56fa201fa932523d40a4f99012a95b.svg";